import React from 'react';
import ChannelList from '../../channels.json';

class Channel extends React.Component {

  render() {
    let logoUrl = 'img/channelLogos/' + ChannelList[this.props.channelId].name + '.png';
    return (
      <div className="channel">
          <img src={logoUrl} alt='' />
          <p className="hidden">
            {ChannelList[this.props.channelId].info.name}
          </p>
      </div>
    );
  }

}

export default Channel;